import http from "@/http-common";

export default class QueryService {
	
	sqlRun(_params) {
		return http.get('/cm/query/sql', { params: _params}).then(res => res.data);
	}

	spCompile(_params) {
		return http.get('/cm/query/sp', { params: _params}).then(res => res.data);
	}

}